module.exports = __webpack_public_path__ + "img/stats_2.3e40f651.png";